import { render, staticRenderFns } from "./UtaiFormData.vue?vue&type=template&id=74984d40&"
import script from "./UtaiFormData.vue?vue&type=script&lang=js&"
export * from "./UtaiFormData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports